import { useState, useRef, useEffect, FC } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useTranslate } from 'hooks/useTranslate';
import { useSocietyAiAgentPage } from '../context/SocietyAiAgentPageContext';
import { apiOptions } from '../constants/apiOptions';
import { ApiProvider } from '../types/ApiProvider';

const ApiSelector: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSocietyAiAgentPage();

  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const current =
    apiOptions.find((o) => o.id === data.selectedApi) ?? apiOptions[0];

  const handleChangeApi = (id: ApiProvider) => {
    actions.handleChangeSelectedApi(id);
    setOpen(false);
  };

  return (
    <div className="navi-api-selector" ref={ref}>
      <button
        type="button"
        className="navi-api-selector__trigger"
        onClick={() => setOpen(!open)}
      >
        <span className="navi-api-selector__dot" />
        {current.label}
        <ChevronDown
          className={`navi-api-selector__chevron${
            open ? ' navi-api-selector__chevron--open' : ''
          }`}
        />
      </button>

      {open && (
        <div className="navi-api-selector__menu" role="menu">
          <div className="navi-api-selector__menu-label">
            {t('CHATBOT_ModelProvider')}
          </div>
          {apiOptions.map((opt) => (
            <button
              key={opt.id}
              type="button"
              className="navi-api-selector__option"
              role="menuitem"
              onClick={() => handleChangeApi(opt.id)}
            >
              <div className="navi-api-selector__option-info">
                <span className="navi-api-selector__option-label">
                  {opt.label}
                </span>
                <span className="navi-api-selector__option-model">
                  {opt.model}
                </span>
              </div>
              {data.selectedApi === opt.id && (
                <Check className="navi-api-selector__option-check" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
export default ApiSelector;
